import type { GameWalletBalance, KeycloakAuth, Luckybox, UserWins } from '$lib/types';
import type { AxiosInstance } from 'axios';
import { GAME_SERVICE_BASE_URL } from '../../constants';
import { getDefaultAxios, getDefaultAxiosWithToken } from './AxiosService';

export class GameService {
	keyCloack: KeycloakAuth | undefined;
	newGameServiceURL = 'staking';
	axios: AxiosInstance;

	constructor(keyCloack: KeycloakAuth) {
		if (keyCloack) {
			this.keyCloack = keyCloack;
			this.axios = getDefaultAxiosWithToken(keyCloack);
		} else {
			this.axios = getDefaultAxios();
		}
	}

	async loadStakingBalance(userId: string, duration: number) {
		if (duration === 0) {
			return this.loadBalance(userId);
		}

		let url = `${GAME_SERVICE_BASE_URL}/staking/id=${userId}&day=${duration}`;
		let resp = await this.axios.get<GameWalletBalance>(url);
		return resp.data;
	}

	async loadBalance(userId: string) {
		let url = `${GAME_SERVICE_BASE_URL}/balance/id=${userId}`;
		let resp = await this.axios.get<GameWalletBalance>(url);
		return resp.data;
	}

	async loadLuckybox(season: number) {
		let url = `${GAME_SERVICE_BASE_URL}/luckyball/luckybox/season=${season}`;
		let resp = await this.axios.get<Luckybox>(url);
		return resp.data;
	}

	async userWins(season: number) {
		let url = `${GAME_SERVICE_BASE_URL}/luckyball/wins/season=${season}`;
		let resp = await this.axios.get<UserWins>(url);
		return resp.data;
	}
}

export function toMonthName(timestamp: number) {
	var date = new Date(timestamp * 1000);
	return date.toLocaleString('default', { month: 'long' });
}

export function toDateNumber(timestamp: number) {
	var date = new Date(timestamp * 1000);
	return String(date.getDate()).padStart(2, '0');
}
